import Modal from 'react-modal';

const ModalMsgCtrl = ({
    txtMsg = '',
    active = false,
    isloading = true,
    closeModal = () => { },
    hideCloseModal = false

}: IModalProps) => {

    if (isloading)
        return (
            <Modal className="modal-re-ni" isOpen={active} style={{overlay: { display: "flex", justifyContent:'center', alignItems:'center', background:'rgba(255, 255, 255, 0.85)'}}} ariaHideApp={false}>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div className="loader-re-ni"></div>
                    </div>
                    <p className="text-center" style={{color:'#008866', fontWeight: 500}}>{txtMsg}</p>
                </div>
            </Modal>
        )
    return (
        <Modal className="modal" isOpen={active} ariaHideApp={false}>
            <div className="modal-title">
                <span className="txt-title-modal">Información</span>
            </div>
            <div className="modal-body-info mt20 mb-20" style={{ textAlign: 'center' }}>
                {txtMsg}
            </div>
            <div className="modal-footer">
                {hideCloseModal === false &&  <button className="modal-btn-close" style={{ background: '#008866' }} onClick={closeModal}>Cerrar</button>}                
            </div>
        </Modal>

    )
}

export { ModalMsgCtrl }